import { Controller } from "@hotwired/stimulus"

// Hides/shows the dashboard stats strip. The preference is a pure client-side
// display choice, so it persists in localStorage (no backend round-trip) and is
// re-applied on connect() — which Stimulus re-runs on every Turbo Drive
// navigation, so the strip stays in the chosen state across page loads.
export default class extends Controller {
  static targets = ["panel", "button", "label", "chevron"]
  static values = { storageKey: { type: String, default: "blume.dashboardStatsOpen" } }

  connect() {
    this.apply(this.isOpen())
  }

  toggle() {
    const next = !this.isOpen()
    localStorage.setItem(this.storageKeyValue, next ? "1" : "0")
    this.apply(next)
  }

  isOpen() {
    // Default to open when nothing has been stored yet.
    return localStorage.getItem(this.storageKeyValue) !== "0"
  }

  apply(open) {
    if (this.hasPanelTarget) this.panelTarget.classList.toggle("hidden", !open)
    if (this.hasLabelTarget) this.labelTarget.textContent = open ? "Hide stats" : "Show stats"
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("is-open", open)
  }
}
